import React from 'react';
import { Box } from '@mui/material';
import { Typography, Button } from '../../index';

interface SearchFiltersProps {
  t: (key: string) => string;
  filterCount?: number;
  onClearAllClick: () => void;
  children?: React.ReactNode;
  filterDescriptionKey?: string;
}

const SearchFilters: React.FC<React.PropsWithChildren<SearchFiltersProps>> = ({
  t,
  filterCount,
  onClearAllClick,
  children,
  filterDescriptionKey,
}: SearchFiltersProps) => {
  return (
    <>
      <Box display="flex" alignItems="baseline" justifyContent="space-between" data-testid="filter-list">
        <Box>
          <Typography variant="h2" component="h2">
            {t('task_filter:header')}
          </Typography>
          {filterDescriptionKey && (
            <Typography variant="body2" component="p" color="textSecondary" sx={{ mb: 4 }}>
              {t(filterDescriptionKey)}
            </Typography>
          )}
        </Box>
        <Button onClick={onClearAllClick} sx={{ textTransform: 'none', mr: 1 }} disabled={!filterCount}>
          {t('ns.task_filter:clear_all_button')}
        </Button>
      </Box>

      {children}
    </>
  );
};

export { SearchFilters };
export * from './FilterSectionWrapper';
